import React, { useEffect, useRef, useState } from 'react';
import '../Community/Tabs/NewsFeed/NewsFeed.css';
import { useModuleContext } from '../../context/ModuleProvider';
import { toast } from 'react-toastify';
import axiosInstance from '../../axiosapi';
import NewsFeed from '../Community/Tabs/NewsFeed/NewsFeed';

const Newsfeed = ({ search, limit = 10 }) => {
  const { url } = useModuleContext();
  const [posts, setPosts] = useState([]);
  const [initialLoading, setInitialLoading] = useState(false);
  const [infiniteLoading, setInfiniteLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const scrollContainerRef = useRef(null);
  const [debouncedSearch, setDebouncedSearch] = useState(search || '');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // Adjust the delay as needed

    return () => clearTimeout(timer);
  }, [search]);

  const fetchPosts = async (page) => {
    page === 1 ? setInitialLoading(true) : setInfiniteLoading(true);
    const token = localStorage.getItem('token');
    axiosInstance({
      method: 'get',
      url: `${url}/posts?page=${page}&search=${debouncedSearch}&limit=${limit}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setPosts((prevPosts) => {
          if (page === 1) {
            return res.data.data;
          } else {
            return [...prevPosts, ...res.data.data];
          }
        });
        setTotalPages(res.data.total_pages || 1);
        setInitialLoading(false);
        setInfiniteLoading(false);
      })
      .catch((error) => {
        toast.error(error.message);
        setInitialLoading(false);
        setInfiniteLoading(false);
      });
  };

  useEffect(() => {
    fetchPosts(page);
  }, [page, debouncedSearch]);

  return (
    <div className="pl-md-2 w-100">
      <section className="newsfeed">
        {initialLoading ? (
          <div className="d-flex flex-column" style={{ gap: '10px' }}>
            {Array.from({ length: 3 }).map((_, index) => (
              <SkeletonLoader key={index} />
            ))}
          </div>
        ) : (
          <div
            className="scrollable-posts scrollable-summary2 mt-2"
            ref={scrollContainerRef}
            onScroll={() => {
              if (
                scrollContainerRef.current.scrollTop + scrollContainerRef.current.clientHeight >=
                scrollContainerRef.current.scrollHeight
              ) {
                if (page < totalPages) {
                  setPage((prevPage) => prevPage + 1);
                }
              }
            }}
          >
            {posts.length ? (
              posts.map((post) => (
                <NewsFeed
                  data={post}
                  key={post.id}
                  handleSuccess={() => {
                    setPosts((prevPosts) =>
                      prevPosts.map((prevPost) =>
                        prevPost.id === post.id
                          ? {
                              ...prevPost,
                              isLiked: !post.isLiked,
                              likes: post.isLiked ? prevPost.likes - 1 : prevPost.likes + 1,
                            }
                          : prevPost,
                      ),
                    );
                  }}
                />
              ))
            ) : (
              <div className="text-center mt-5">
                <h6>No posts available</h6>
              </div>
            )}
          </div>
        )}
        {infiniteLoading && <SkeletonLoader />}
      </section>
    </div>
  );
};

function SkeletonLoader() {
  return (
    <div className="qa-card-skeleton w-100">
      <div className="header">
        <div className="skeleton avatar" />
        <div className="user-info">
          <div className="skeleton name" />
          <div className="skeleton date" />
        </div>
        <div className="skeleton tag" />
      </div>
      <div className="skeleton title" />
      <div className="skeleton message" />
      <div className="skeleton images" />
    </div>
  );
}

export default Newsfeed;
